import { media } from "@/styles/media";
import { theme } from "@/styles/theme";
import styled, { keyframes } from "styled-components";

type TWaveTextProps = {
  text: string;
};

export default function Wave({ text }: TWaveTextProps) {
  return (
    <H1>
      <WaveWrap>
        {text.split("\n").map((line, lineIndex) => (
          <div key={`line-${lineIndex}`}>
            {line.split("").map((char, charIndex) => (
              <WaveText
                key={`char-${lineIndex}-${charIndex}`}
                delay={lineIndex * text.split("\n")[0].length * 20 + charIndex * 20}
              >
                {char}
              </WaveText>
            ))}
          </div>
        ))}
      </WaveWrap>
    </H1>
  );
}

const waveAnimation = keyframes`
  0% { transform: translateY(100%); }
  100% { transform: translateY(0); }
`;

const WaveWrap = styled.div`
  display: inline-block;
  overflow: hidden;
`;

const WaveText = styled.span<{ delay: number }>`
  display: inline-block;
  transform: translateY(100%);
  animation: ${waveAnimation} 0.6s cubic-bezier(0.77, 0, 0.175, 1) forwards;
  animation-delay: ${({ delay }) => `${delay}ms`};
`;

const H1 = styled.h1`
  width: 100%;
  margin: 0 10px 0 0;
  font-size: 2.8rem;
  font-weight: 700;
  white-space: pre-wrap;
  line-height: 110%;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5), 2px 2px 4px rgba(255, 255, 255, 0.4),
    3px 3px 6px rgba(255, 255, 255, 0.1);
  color: ${theme.colors.primary};

  ${media.tablet`
    display: none;  
  `}
`;
